// import { HttpInterceptorFn } from '@angular/common/http';

// export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {

//   const excludedUrls = [
//     '/auth/',
//     '/api/v1/',
//     '/translate/v2'
//   ];

//   const shouldSkip = excludedUrls.some(url =>
//     req.url.includes(url)
//   );

//   // if (shouldSkip) {
//   //   return next(req);
//   // }


//   const clonedReq = req.clone({
//     withCredentials: true
//   });


//   console.log(
//     '[Credentials]',
//     req.url,
//     req.withCredentials
//   );

//   return next(clonedReq);
// };


import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.API_URL)) {
    return next(req);
  }

  const clonedReq = req.clone({
    withCredentials: true
  });

  return next(clonedReq);
};
